var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('ImageVue',{class:{ white: _vm.white, infoImg: _vm.outside },attrs:{"src":'dynamic/info.svg',"size":"14px"}}),_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }